import React from "react";
import { Link, Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Button, Card, Col, Divider, Form, Input, Row, Typography, Upload, message } from "antd";
import { IoAlbums, IoApps, IoArrowBackCircle, IoBusiness, IoClipboard, IoCloseCircle, IoGrid, IoMap, IoPeople, IoMan, IoSettings, IoIdCard, IoCalendar, IoDocument, IoBook, IoCalculator, IoAperture, IoStar } from "react-icons/io5";
import { RiGraduationCapFill } from "react-icons/ri";

import { POST_API, POST_CATCH, getToken, getUPLOADAPI } from "../services/hello-api";

import Pageload from "../components/Pageload";
import { IoCameraOutline } from "react-icons/io5";

class MenuConfiguracoes extends React.Component {

    state = { _loading: true, _navigate: false, _user: null, _menu: false }

    componentDidMount = () => {
        this.onView()
    }

    onView = () => {
        this.setState({_loading: true})
        if (getToken()) {
            POST_API('/credential/verify.php', { token: getToken() }).then(rs => rs.json()).then(res => {
                if (!res.return) {
                    this.setState({_navigate: true})
                } else {
                    this.setState({_user: res.user})
                }
            }).catch(() => POST_CATCH()).finally(() => {
                this.setState({_loading: false})
            })
        } else {
            this.setState({_navigate: true})
        }
    }

    render = ( ) => {

        const routes = this.props.bread

        if (this.state._navigate) return <Navigate to="/" />

        if (this.state._user === null || this.state._loading) return <Pageload />

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={24}>
                            <Breadcrumb items={routes} />
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content menu">
                    { this.state._user.TYPE_ACCOUNT_ID === "1" ? (
                        <Row gutter={[16,16]}>
                            <Col xs={12} md={4}>
                                <Link to="permissoes">
                                    <Card hoverable className="menu-card">
                                        <center><IoAperture size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Permissões</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="usuarios">
                                    <Card hoverable className="menu-card">
                                        <center><IoPeople size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Usuários</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="tipousuario">
                                    <Card hoverable className="menu-card">
                                        <center><IoApps size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Tipos de Usuário</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="logs">
                                    <Card hoverable className="menu-card">
                                        <center><IoBook size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Logs</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                        </Row>
                    ) : null }
                    { this.state._user.TYPE_ACCOUNT_ID === "2" ? (
                        <Row gutter={[16,16]}>
                            <Col xs={12} md={4}>
                                <Link to="turmasituacao">
                                    <Card hoverable className="menu-card">
                                        <center><IoAlbums size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Situação Turma</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="usuarios">
                                    <Card hoverable className="menu-card">
                                        <center><IoPeople size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Usuários</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="tipousuario">
                                    <Card hoverable className="menu-card">
                                        <center><IoApps size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Tipos de Usuário</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="categoria">
                                    <Card hoverable className="menu-card">
                                        <center><IoBook size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Categ. Briefing</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="item">
                                    <Card hoverable className="menu-card">
                                        <center><IoCalculator size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Itens Calc. Eventos</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="eventostatus">
                                    <Card hoverable className="menu-card">
                                        <center><IoStar size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Status Evento</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4}>
                                <Link to="eventofase">
                                    <Card hoverable className="menu-card">
                                        <center><IoStar size={20} className="menu-card-icon" /></center>
                                        <center><Typography className="menu-card-text">Fase Evento</Typography></center>
                                    </Card>
                                </Link>
                            </Col>
                        </Row>
                    ) : null }
                </Col>
            </Row>
        )
    }

}

export default MenuConfiguracoes;